// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spotlight-modules[data-v-a268bf58]{max-width:100%;display:grid;grid-template-columns:repeat(2,calc(50% - 16px));grid-gap:24px;grid-auto-rows:180px;justify-content:space-between;grid-row-gap:48px}@media(max-width:767px){.spotlight-modules[data-v-a268bf58]{grid-template-columns:100%}}@media(min-width:1200px){.spotlight-modules[data-v-a268bf58]{grid-template-columns:repeat(2,calc(50% - 32px))}}.spotlight-modules.single[data-v-a268bf58]{grid-template-columns:100%}", ""]);
// Exports
module.exports = exports;
